import { select, getAttribute, addClass, removeClass, on, selectAll, getData, setAttribute } from 'modules/dom'
import { map } from 'modules/utils'
import { initializeModuleForEl } from './../../src/js/lib/init-modules.js'

const CLASS_ACTIVATE_TAB_PANE = 'tab_pane--active'
const CLASS_ACTIVATE_NAV_TAB = 'nav-tabs__item--activate'
const SELECTOR_NAV_TAB_LINK = '.js-nav-tabs__link'
const CLASS_NO_RELOAD = 'js-tab-panel-no-reload'

export default function (el) {
  const navTabItems = selectAll(SELECTOR_NAV_TAB_LINK, el)
  const dataTab = getData('tab', el)

  const changeUrlPagination = (tab) => {
    const href = getAttribute('href', tab)
    const tabId = href.replace('#', '')
    const tabPanel = select(href, el)
    const pagination = tabPanel ? select('.pagination', tabPanel) : false
    const dataPage = tabPanel ? getData('page', tabPanel) : false
    if (pagination && dataPage && dataPage != 1) {
      const prev = select('.prev', pagination)
      const next = select('.next', pagination)
      var pageNumbers = selectAll('.page-numbers', pagination)
      pageNumbers.shift()
      pageNumbers.pop()
      const firstHrefPagination = getAttribute('href', pageNumbers[0]) + "?tab=" + tabId
      setAttribute('href', firstHrefPagination, pageNumbers[0] )
      if (dataPage == 2) {
        setAttribute('href', firstHrefPagination, prev )
      }
    }
    return false;
  }



  const activateTabPanel = function (id) {
    const tabPanel = select(id, el)
    if (tabPanel) {
      addClass(CLASS_ACTIVATE_TAB_PANE, tabPanel)
      if (!tabPanel.classList.contains(CLASS_NO_RELOAD)) {
        selectAll('[data-module-init]', tabPanel).map(initializeModuleForEl)
      }
    }
    return false
  }

  const deactivateTabPanelActive = function () {
    const tabPanel = select('.' + CLASS_ACTIVATE_TAB_PANE, el)
    if (tabPanel) {
      removeClass(CLASS_ACTIVATE_TAB_PANE, tabPanel)
    }
    return false
  }

  const activateNavTab = function (tab) {
    const navTabLink = select('[href="#' + tab + '"]', el)
    if (navTabLink) {
      addClass(CLASS_ACTIVATE_NAV_TAB, navTabLink.parentNode)
    }
    return false
  }

  const deactivateNavTabActive = function () {
    const navTabItem = select('.' + CLASS_ACTIVATE_NAV_TAB, el)
    if (navTabItem) {
      removeClass(CLASS_ACTIVATE_NAV_TAB, navTabItem)
    }
    return false
  }

  const activateTab = function (href) {
    const navTabPanel = select(href, el)
    if ( !navTabPanel ) {
      href = getAttribute('href', navTabItems[0])
    }
    const tab = href.replace('#', '')
    deactivateNavTabActive()
    activateNavTab(tab)
    deactivateTabPanelActive()
    activateTabPanel(href)
  }

  const init = function () {
    const navTabItem = select('.' + CLASS_ACTIVATE_NAV_TAB, el)
    const navTabLink = navTabItem ? select(SELECTOR_NAV_TAB_LINK, navTabItem) : false;
    if (navTabLink) {
      const href = getAttribute('href', navTabLink)
      if (navTabLink != '#') {
        activateTabPanel(href)
      }
    }
    if (dataTab) {
      const href = '#' + dataTab
      activateTab(href)
    }

    map((el) => {
      on('click', function (e) {
        e.preventDefault()
        const href = getAttribute('href', el)
        activateTab(href)
        return false
      }, el)
    }, navTabItems)
    map((el) => changeUrlPagination(el), navTabItems)
  }

  init()
}
